<template>
  <surround
    :title="title"
    :surround-image="surroundImage"
    :back-link="backLink"
  >
    <div class="iframepage">
      <IframeBox
        ref="theframe"
        :css-class="'ifb'"
        :src="src"
      />
      <div class="extra-content">
        <slot />
      </div>
    </div>
  </surround>
</template>

<script>
import Surround from '../components/Surround'
import IframeBox from '../components/IframeBox'

export default {
    name: 'IframeSurroundPage',
    components: {
        Surround,
        IframeBox
    },
    props: {
        src: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        surroundImage: {
            type: String,
            default: ''
        },
        backLink: {
            type: [String, Object, Boolean],
            default: false
        }
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            // src: process.env.BASE_URL + 'frames/testframe.html'
        }
    },
    mounted() {
        window.addEventListener('message', this.handleMessage)
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleMessage)
    },
    methods: {
        handleMessage(event) {
            if (event.source !== this.$refs.theframe.$el.contentWindow) {
                return
            }
            this.$emit('iframe-message', event)

            // // Track in GTM - why not?
            // event.data.event && this.$gtm.trackEvent({
            //     action: event.data.event,
            //     category: 'Iframe action',
            //     label: event.data.data
            // })
        }
    }
}
</script>

<style lang="scss" scoped>
.iframepage {
    @include flex-vertical;
    @include flex-fill-vertical;
    background: black;
}
iframe {
    @include flex-fill-vertical;
}
</style>